// @flow
import React from 'react'
import { Select } from 'antd'

const Option = Select.Option

export type OptionItemType = {
  label: string,
  value: any,
}

type PropTypes = {
  selectProps: Object,
  optionList: Array<OptionItemType>,
}

export default (props: PropTypes) => (
  <Select {...props.selectProps}>
    {props.optionList.map(({ value, label }, index) => (
      <Option key={index} value={value}>
        {label}
      </Option>
    ))}
  </Select>
)



// WEBPACK FOOTER //
// ./src/components/atoms/SelectItem/index.jsx